import { ApplicationDataSourceRegistry } from '../application/service/ApplicationDataSourceRegistry';
import { SETTINGS } from '../config';
import { TaskReader } from './task.read.service';

export function registerTaskDataSources(promiseService, clusterService) {
  const registerOnce = (config) => {
    if (!ApplicationDataSourceRegistry.getDataSources().some(({ key }) => key === config.key)) {
      ApplicationDataSourceRegistry.registerDataSource(config);
    }
  };

  const addTasks = (application, tasks) => {
    return promiseService.resolve(Array.isArray(tasks) ? tasks : []);
  };

  const loadPaginatedTasks = async (application, page = 1) => {
    let limitPerPage = SETTINGS.tasksViewLimitPerPage;
    const tasks = await TaskReader.getTasks(application.name, [], limitPerPage, page);
    if (tasks.length === limitPerPage) {
      return tasks.concat(await loadPaginatedTasks(application, page + 1));
    } else {
      return tasks;
    }
  };

  const loadTasks = (application, page = 1) => {
    let limitPerPage = SETTINGS.tasksViewLimitPerPage;
    if (limitPerPage === undefined) {
      return TaskReader.getTasks(application.name);
    } else {
      return loadPaginatedTasks(application, page);
    }
  };

  const loadRunningTasks = (application) => {
    return TaskReader.getRunningTasks(application.name);
  };

  const addRunningTasks = (application, data) => {
    return promiseService.resolve(data);
  };

  const runningTasksLoaded = (application) => {
    const serverGroups = application.getDataSource('serverGroups');
    if (!serverGroups) {
      return;
    }

    clusterService.addTasksToServerGroups(application);
    serverGroups.dataUpdated();
  };

  registerOnce({
    key: 'tasks',
    sref: '.tasks',
    badge: 'runningTasks',
    category: 'tasks',
    loader: loadTasks,
    onLoad: addTasks,
    afterLoad: runningTasksLoaded,
    lazy: true,
    primary: true,
    icon: 'fa fa-sm fa-fw fa-check-square',
    iconName: 'spMenuTasks',
    defaultData: [],
  });

  registerOnce({
    key: 'runningTasks',
    visible: false,
    loader: loadRunningTasks,
    onLoad: addRunningTasks,
    defaultData: [],
  });
}
